(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.friga-shipping').forEach(function (wrap) {
    var input = wrap.querySelector('.friga-shipping__input');
    var btn = wrap.querySelector('.friga-shipping__btn');
    var result = wrap.querySelector('.friga-shipping__result');
    var disclaimer = wrap.querySelector('.friga-shipping__disclaimer');
    var variantId = wrap.dataset.variantId;

    if (!input || !btn || !result) return;

    function formatCep(value) {
      return value.replace(/\D/g, '').replace(/^(\d{5})(\d)/, '$1-$2').slice(0, 9);
    }

    function formatMoney(cents) {
      if (cents === 0) return 'Grátis';
      return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function showResult(html, showDisclaimer) {
      result.innerHTML = html;
      result.hidden = false;
      if (disclaimer) disclaimer.hidden = !showDisclaimer;
    }

    function addItem(id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1, properties: { _friga_shipping_probe: '1' } })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      });
    }

    function removeItem(key) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    function fetchRates(zip, province) {
      var url =
        '/cart/shipping_rates.json?shipping_address[zip]=' +
        encodeURIComponent(zip) +
        '&shipping_address[country]=BR' +
        '&shipping_address[province]=' +
        encodeURIComponent(province);
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('rates');
        return r.json();
      });
    }

    function query() {
      var raw = input.value.replace(/\D/g, '');
      if (raw.length < 8) {
        showResult('<p class="friga-shipping__error">Digite um CEP válido (8 dígitos).</p>', false);
        return;
      }

      btn.disabled = true;
      showResult('<p class="friga-shipping__loading">Consultando...</p>', false);

      var probeKey = null;

      fetch('https://viacep.com.br/ws/' + raw + '/json/')
        .then(function (r) {
          if (!r.ok) throw new Error('cep');
          return r.json();
        })
        .then(function (cep) {
          if (cep.erro) throw new Error('cep_invalid');
          var uf = cep.uf || '';

          return addItem(variantId).then(function (added) {
            probeKey = added.key;
            return fetchRates(raw, uf);
          });
        })
        .then(function (data) {
          var rates = data.shipping_rates || [];
          if (rates.length === 0) {
            showResult('<p class="friga-shipping__error">Nenhuma opção de entrega encontrada para este CEP.</p>', false);
          } else {
            var html = rates.map(function (rate) {
              var price = Math.round(parseFloat(rate.price) * 100);
              var isFree = price === 0;
              var cls = isFree
                ? 'friga-shipping__rate-price friga-shipping__rate-price--free'
                : 'friga-shipping__rate-price';
              return (
                '<div class="friga-shipping__rate">' +
                '<span class="friga-shipping__rate-name">' + rate.name + '</span>' +
                '<span class="' + cls + '">' + formatMoney(price) + '</span>' +
                '</div>'
              );
            }).join('');
            showResult(html, true);
          }
        })
        .catch(function (e) {
          if (e.message === 'cep_invalid') {
            showResult('<p class="friga-shipping__error">CEP não encontrado. Verifique e tente novamente.</p>', false);
          } else {
            showResult('<p class="friga-shipping__error">Erro ao consultar. Tente novamente.</p>', false);
          }
        })
        .finally(function () {
          if (probeKey) removeItem(probeKey);
          btn.disabled = false;
        });
    }

    input.addEventListener('input', function () {
      input.value = formatCep(input.value);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') query();
    });

    btn.addEventListener('click', query);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
